import "./cards.css"
import {VictoryLine} from "victory"
import ReactCardFlip from "react-card-flip"
import React, { Component } from "react"
import copy from "copy-to-clipboard"
class RecommendationCard extends Component{
    constructor(props){
        super(props)
        var recommendation = props.recommendation
        this.state = (() => {
            var dailyhistory = JSON.parse(recommendation.dailyhistory)
            var pointedprice = dailyhistory[0]["close"]
            var graphdata = []
            for(var i = 0; i < dailyhistory.length; i++){
                graphdata.push({x: i + 1, y: parseFloat(dailyhistory[i]["close"])})
            }
            return {
                name: recommendation.company.length > 16 && window.innerWidth > 576? recommendation.company.substring(0, 16) + "..." : recommendation.company,
                fullname: recommendation.company,
                pricepercent: (recommendation.targetdifference * 100 / pointedprice).toFixed(2),//((props.indicatedprice / props.pointedprice) * 100).toFixed(2),
                indicatedprice: recommendation.targetdifference,//props.indicatedprice > 0? <font color="#4CAF50">{"+" + props.indicatedprice + "(" + pricepercent + "%)"}</font>:<font color="#F44336">{props.indicatedprice + "(" + pricepercent + "%)"}</font>,
                pointedprice: parseFloat(pointedprice).toFixed(2),
                recommendationcount: recommendation.noofrecommendations,//props.recommendationcount,
                dailyhistory: dailyhistory,
                leadpercent: Math.round(recommendation.noofcompaniesbelow * 100 / props.noofcompanies),
                openedat: parseFloat(dailyhistory[0]["open"]).toFixed(2),//props.openedat,
                closedat: parseFloat(dailyhistory[0]["close"]).toFixed(2),//props.closedat,
                high: parseFloat(dailyhistory[0]["high"]).toFixed(2),//props.closedat,
                low: parseFloat(dailyhistory[0]["low"]).toFixed(2),//props.closedat,
                volume: dailyhistory[0]["volume"],//props.closedat,
                arthscore: (recommendation.arthscore > 1? 100:recommendation.arthscore * 100).toFixed(2),//props.closedat,
                data: graphdata.reverse(),
                symbol: recommendation.symbol.length > 10 && window.innerWidth > 576? recommendation.symbol.substring(0, 7) + "..." : recommendation.symbol,
                symbolfull: recommendation.symbol,
                recommender: recommendation.recommender,
                targetprice: recommendation.targetprice,
                mintargetprice: recommendation.minimumtargetprice,
                maxtargetprice: recommendation.maximumtargetprice,
                meantargetprice: ((recommendation.targetprice + recommendation.minimumtargetprice + recommendation.maximumtargetprice) / 3).toFixed(2),
                brokerages: recommendation.brokerages,
                relevance: recommendation.relevance,
                showsharemenu: false,
                showbrokeragetable: false
            }
        })()
    }
    
    flipThisCard(flip){
        const newstate = {...this.state}
        newstate.isFlipped = flip
        this.setState(newstate)
    }
    toggleShareMenu(){
        const newstate = {...this.state}
        newstate.showsharemenu = !this.state.showsharemenu
        this.setState(newstate)
    }
    showBrokerages(){
        var brokerages = this.state.brokerages
        var rows = []
        for(var i = 0; i < brokerages.length; i++){
            var timestamp = Math.floor(((new Date().getTime() / 1000) - brokerages[i].timestamp) / 86400)
            rows.push(<div className="c_brokerages_row">{brokerages[i].recommender}: {brokerages[i].targetprice} INR, {timestamp}d ago</div>)
        }
        return rows
    }
    shareAction(method){
        switch(method){
            case 1:
                copy(`Buy ${this.state.fullname}, current price: ${this.state.pointedprice}, upside: +${this.state.indicatedprice}(${this.state.pricepercent}%), target price: ${this.state.targetprice}, recommended by ${this.state.recommendationcount} brokerage`)
                break
            case 2:
                break
            case 3: 
                break
            case 4: 
                break
            default: 
                break
        }
        const newstate = {...this.state}
        newstate.showsharemenu = !this.state.showsharemenu
        this.setState(newstate)
    }
    toggleBrokerageTable(value){
        const newstate = {...this.state}
        newstate.showbrokeragetable = value
        this.setState(newstate)
    }
    render(){
        return <div onMouseLeave={this.flipThisCard.bind(this, false)} className="c_recommendation_card">
            <ReactCardFlip isFlipped={this.state.isFlipped}>
                <div className="c_card_front" onMouseEnter={this.flipThisCard.bind(this, true)}>
                    <table>
                        <tbody>
                            <tr>
                                <th><img alt="Logo"className="c_recommendation_logo"src="favicon.ico"/></th>
                                <th className="c_recommendation_name">{this.state.name}</th>
                            </tr>
                        </tbody>
                    </table>
                    <hr/>
                    <div className="c_card_pointedprice">{this.state.pointedprice} <font size="3">INR</font></div>
                    <div className="c_card_indicatedprice"><font color="#4CAF50">upside: {"+" + this.state.indicatedprice + "(" + this.state.pricepercent + "%)"}</font></div>
                    <div className="c_card_recommendationtext">Recommended by {this.state.recommendationcount} brokerage</div>
                    <div className="c_card_targettext">Target: {this.state.meantargetprice}</div>
                    <div className="c_card_detailarea">
                        <div className="c_card_graph_container">
                            <VictoryLine interpolation="basis" style={{data: { stroke: "#4CAF50", strokeWidth: 10 }}} className="c_card_graph" data={this.state.data}/>
                        </div>
                        <div className="c_card_openingclosing">
                            <div className="c_card_openingclosingheader">Opened At</div>
                            <div className="c_card_openingclosingdetail">{this.state.openedat}</div>
                            <div className="c_card_openingclosingheader">Closed At</div>
                            <div className="c_card_openingclosingdetail">{this.state.closedat}</div>
                        </div>
                    </div>
                </div>
                <div className="c_card_back" onMouseLeave={this.flipThisCard.bind(this, false)}>
                    
                    <table style={{width: "100%"}}>
                        <thead style={{color: "#2196F3"}}>
                            <tr>
                                <th title={this.state.symbolfull} onMouseEnter={this.toggleBrokerageTable.bind(this, true)} onMouseLeave={this.toggleBrokerageTable.bind(this, false)}>{this.state.symbol} &#x25BC;<div style={{display: this.state.showbrokeragetable?"block":"none"}} className="c_brokerages_table">
                                    Brokerages:
                                    {this.showBrokerages()}
                                </div></th>
                                <th colSpan="3" style={{textAlign: "end"}}><img alt="Share" onClick={this.toggleShareMenu.bind(this)} src="/share.png" width="20px"/>
                                <div style={{display: this.state.showsharemenu?"block":"none"}} className="c_shareMenu">
                                    <div onClick={this.shareAction.bind(this, 1)} className="c_share_elements">Copy Link</div>
                                </div></th>
                            </tr>
                        </thead>
                        <tbody style={{fontSize: "13px", color:"#607D8B"}}>
                            <tr>
                                <td>High:</td>
                                <td colSpan="3">{this.state.high}</td>
                            </tr>
                            <tr>
                                <td>Low:</td>
                                <td colSpan="3">{this.state.low}</td>
                            </tr>
                            <tr>
                                <td>Volume: {}</td>
                                <td colSpan="3">{this.state.volume}</td>
                            </tr>
                            <tr>
                                <td rowSpan="2">Target: {}</td>
                                <td>Min</td>
                                <td>Max</td>
                                <td>Mean</td>
                            </tr>
                            <tr>
                                <td>{this.state.mintargetprice}</td>
                                <td>{this.state.maxtargetprice}</td>
                                <td>{((this.state.targetprice + this.state.maxtargetprice + this.state.mintargetprice) / 3).toFixed(0)}</td>
                            </tr>
                        </tbody>
                    </table>
                    <font size={3} color="#2196F3">Why is this recommended?</font><br/>
                    <p className="c_info_paragraph" onClick={this.flipThisCard.bind(this, false)}>{this.state.fullname} has Arth Score of {this.state.arthscore} Which is greater than {this.state.leadpercent} percent of the companies.</p>
                    {/* <p className="c_hoverable_text_green">See how Arth Score is calculated.</p> */}
                    <font size={2} color="#263238">Recommended on {(() => {
                        var date = new Date(this.state.relevance * 1000)
                        return date.getDate() + "/" + date.getMonth() + "/" + date.getFullYear()
                    })()}</font>
                    {/* <font size={3} color="#263238">From </font><font size={3} color="#FF5722">{this.state.recommender}</font> */}
                </div>
            </ReactCardFlip>
            {/* 
             */}
        </div>
    }
}

export default RecommendationCard